<template>
  <div v-loading.fullscreen.lock="loading" >
    <h2>Réinitialiser son mot de passe</h2>
    <el-form :inline="true" >
      <el-form-item label="Mot de passe" >
        <el-input type="password" v-model="password" />
      </el-form-item>
      <el-form-item label="Confirmation" >
        <el-input type="password" v-model="passwordConfirm" />
      </el-form-item>
      <el-button type="primary" @click="resetPassword" v-loading="loading">Valider</el-button>
    </el-form>
  </div>
</template>

<script>
import {api} from 'macarons'

export default {
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      password: null,
      passwordConfirm: null,
      loading: false
    }
  },
  methods: {
    resetPassword () {
      if (this.password === null) {
        this.$notify.error({
          title: 'Erreur',
          message: 'Le mot de passe doit être renseigné'
        })
      } else if (this.password.length < 8) {
        this.$notify.error({
          title: 'Erreur',
          message: 'Le mot de passe doit faire au minimum 8 caractères'
        })
      } else if (this.password !== this.passwordConfirm) {
        this.$notify.error({
          title: 'Erreur',
          message: 'Le mot de passe et la confirmation ne sont pas identiques'
        })
      } else {
        this.loading = true
        api.post('security/forgot-password?token=' + this.token, {
          plainPassword: this.password
        }).then(({data}) => {
          this.$store.commit('setToken', data.value)
          this.$store.commit('setUser', data.user)
          this.$store.dispatch('load').then(() => {
            this.$router.push('/')
          })
        }).catch(({response}) => {
          if (response.status === 401) {
            this.$notify.error({
              title: 'Erreur',
              dangerouslyUseHTMLString: true,
              message: 'Votre lien de réinitialisation est expiré, merci d\'en demander un nouveau'
            })
            this.$router.push('/forgot-password')
          } else {
            this.$notify.error({
              title: 'Erreur',
              message: 'Une erreur est survenue pendant la réinitialisation du mot de passe.'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/security/components/ResetPassword.vue